//Payload for checkout flow

import { calculateAmountsAndBreakdowns } from "../../../helpers/itemCalculations";
import {
  orderItems,
  orderSurcharges,
} from "../../../helpers/orderPayloadBuilder";
import { verificationPayloadParameterType } from "../types/promotionTypes";

export function verificationPayloadCreator({
  userCartItems,
  menu,
  orderType,
  discount,
  redeemedPoints,
  selectedArea,
  deliveryChargeId,
  riderTip,
  orderPromotions,
  company,
  outlet,
  user,
  customer_loyalty,
}: verificationPayloadParameterType) {
  const cartBreakdowns = calculateAmountsAndBreakdowns(
    userCartItems,
    menu,
    orderType,
    discount || null,
    redeemedPoints || null,
    selectedArea || {},
    outlet.delivery_charge_id || null,
    riderTip || null,
    orderPromotions || []
  );

  const { id: online_company_id, currency } = company;

  const { id: online_location_id } = outlet;

  const {
    sapaad_customer_id: customer_id,
    name: user_name = "",
    email: user_email = "",
  } = user;

  const {
    subTotal: sub_total,
    subTotalAfterDiscount: sub_total_after_discount,
    subTotalTaxAfterDiscount: sub_total_tax_after_discount,
    surchargeSubTotal: surcharge_sub_total,
    surchargeBreakDown: surcharges_breakdown,
    taxTotal: tax_total,
    total: total_amount,
    totalBeforeLoyalty: total_before_loyalty,
  } = cartBreakdowns;

  const discounts =
    discount && Object.keys(discount).length
      ? [
          {
            id: discount.discount_id,
            name: discount.discount_name,
            type: discount.discount_type.toLowerCase(),
            discount_type: discount.discount_type === "PERCENTAGE" ? 1 : 2,
            on_total: discount.on_total,
            rate: discount.discount_rate,
            amount: discount.discountedAmount,
          },
        ]
      : [];

  const paymentData = {
    id: 0,
    payment_type_id: 0,
    payment_type: "",
    amount: 0,
    name: "",
    tips: 0,
  };

  const payload = {
    online_company_id,
    online_location_id,
    scheduled_at: null,
    default_eta: null,
    online_delivery_eta: null,
    note: { user: "", meta: "" },
    surcharges:
      orderSurcharges(
        menu.surcharges,
        menu.taxes,
        orderType,
        selectedArea || {},
        outlet.delivery_charge_id
      ) ?? [],
    items: orderItems(userCartItems || [], []),
    delivery_address_id: null,
    delivery_area: selectedArea?.name || "",
    complete_address: "",
    discounts,
    redeemed_loyalty: redeemedPoints || 0,
    remaining_loyalty: redeemedPoints ? (customer_loyalty || 0) - (redeemedPoints || 0) : (customer_loyalty || 0),
    earned_loyalty: 0,
    has_loyalty_data: redeemedPoints ? true : false,
    loyalty_as_discount: false,
    sub_total,
    sub_total_after_discount,
    sub_total_tax_after_discount,
    surcharge_sub_total,
    surcharges_breakdown,
    tax_total,
    total_amount,
    total_before_loyalty,
    order_type: orderType,
    customer_id,
    is_tax_inclusive: menu.is_tax_inclusive,
    pickup_mode: "",
    user_name,
    user_email,
    currency,
    applied_promotions: [],
    payment: paymentData,
  };

  return payload;
}
